
//vercel
export const serverUrl = "https://tcmg-back-end.vercel.app";


//localhost
// export const serverUrl = "http://localhost:2000";


//cyclic
// export const serverUrl = "https://long-bass-umbrella.cyclic.app";
// export const serverUrl = "https://real-gold-sawfish-veil.cyclic.app";



// export const serverUrl = "https://tcmg-back-end.vercel.app/";


// export const serverUrl = "https://admin.markzk.com/";